angular.module('impactx.dashboard').controller('BudgetOwnCtrl', ['$scope', 'dataGen', 'ToolbarService', BudgetOwnCtrl]);

function BudgetOwnCtrl($scope, dataGen, ToolbarService) {
    dataGen.getData($scope, {}, "/budget/viewown");
    ToolbarService.setButtons([]);
}